import { Controller } from "@hotwired/stimulus"
import IMask from "imask"

export default class MaskController extends Controller {
    static get targets() {
        return ['date', 'customtime']
    }

    connect() {
        if (this.hasDateTarget) {
            const visibleInput = this.element.nextElementSibling
            if (visibleInput?.tagName !== "INPUT") {
                console.warn("No visible input found for masking")
                return
            }

            this.dateMask = IMask(visibleInput, {
                overwrite: true,
                mask: 'MM-DD-YYYY',
                lazy: true,
                autofix: true,
                blocks: {
                    MM: {
                        mask: IMask.MaskedRange,
                        placeholderChar: '-',
                        from: 1,
                        to: 12,
                        maxLength: 2,
                        autofix: true
                    },
                    DD: {
                        mask: IMask.MaskedRange,
                        placeholderChar: '-',
                        from: 1,
                        to: 31,
                        maxLength: 2,
                        autofix: true
                    },
                    YYYY: {
                        mask: '0000',
                        placeholderChar: '-',
                        autofix: true
                    }
                }
            });
        } else if (this.hasCustomtimeTarget) {
            this.mask = IMask(this.element, {
                overwrite: true,
                autofix: true,
                mask: 'HH{:}mm AA',
                lazy: false,
                blocks: {
                    HH: {
                        mask: IMask.MaskedRange,
                        from: 1,
                        to: 12,
                        maxLength: 2,
                        autofix: true
                    },
                    mm: {
                        mask: IMask.MaskedRange,
                        from: 0,
                        to: 59,
                        maxLength: 2,
                        autofix: true
                    },
                    AA: {
                        mask: IMask.MaskedEnum,
                        enum: ["AM", "PM"],
                        prepare: str => str.toUpperCase()
                    }
                    }
            });
        } else {
            this.mask = IMask(this.element, {
                overwrite: true,
                autofix: true,
                mask: 'h{:}mm A',
                lazy: false,
                blocks: {
                    h: {
                        mask: IMask.MaskedRange,
                        placeholderChar: '-',
                        from: 0,
                        to: 12,
                        maxLength: 2,
                        autofix: true
                    },
                    mm: {
                        mask: IMask.MaskedRange,
                        placeholderChar: '-',
                        from: 0,
                        to: 59,
                        maxLength: 2,
                        autofix: true
                    },
                    A: {
                        mask: IMask.MaskedEnum,
                        placeholderChar: '-',
                        maxLength: 2,
                        enum: ['AM', 'am', 'PM', 'pm', 'aM', 'Am', 'pM', 'Pm']
                    }
                }
            });
        }
    }

    disconnect() {
        this.mask?.destroy();
        this.dateMask?.destroy();
    }
}